/**
 * The client's home, named once: what its parts are called and the way round
 * under the price. The home draws its headings and links from here, and so
 * does anything that speaks of the home (the Introduction), so a help panel
 * can only ever use the home's own words (Jason, 2026-10-06: help must be
 * "snapshots of the real app", never invented).
 */

/** The parts of the home, in the order they come down the page. */
export const HOME_SECTIONS = [
  { key: 'price', name: 'The price bar' },
  { key: 'waiting', name: 'Waiting on you' },
  { key: 'funnel', name: 'How the price firms up' },
  // Under the funnel (design study 31): what is under way and what it works toward, then the whole tree.
  { key: 'working', name: 'Working on' },
  { key: 'tree', name: 'Project process tree' },
  { key: 'board', name: 'The design board' },
] as const;

export type HomeSectionKey = (typeof HOME_SECTIONS)[number]['key'];

export const homeSection = (key: HomeSectionKey): string => HOME_SECTIONS.find((s) => s.key === key)!.name;

/** The way round the project, just under the price (Jason, 2026-10-03): always all of it. `unset`: the label before there is one. */
export const WAY_ROUND = [
  { path: 'budget', label: 'Your budget', unset: 'Set your budget' },
  { path: 'timeline', label: 'Timeline' },
  { path: 'files', label: 'Files' },
  { path: 'board', label: 'Design board' },
  // Once the step carrying it is reached (spec "Pattern Mapping" §4.4): their sections say so.
  { path: 'patterns', label: 'Patterns' },
  { path: 'reviews', label: 'Design reviews' },
  { path: 'decisions', label: 'Your decisions' },
] as const;

export type WayRoundPath = (typeof WAY_ROUND)[number]['path'];
